import _typeof from "@babel/runtime/helpers/typeof";
import Logger from "./log";

// 必填参数
var requiredParameters = ['cookieid',
//	惟一标识	getCookie('idzz')/getCookie('id58')/getUid()/getCookie('uuid')
'pagetype',
//	行为类型	埋点行为
'actiontype',
//	页面类型	输入pageid在高斯平台申请
'appid',
//	应用id	
'clientip',
//		客户端ip
'timestamp',
//		记录时间
'cate',
//		类别id
'city',
//		城市id
'backup',
//		备用字段，如果上报，请上报json格式内容
'source',
//		来源:app, m,微信, pc
'devid',
//		设备id： android,ios,pc
'channelid',
//		渠道id
'ua',
//		设备型号
'version',
//		客户端版本
'os',
//		操作系统名称
'osv',
//		操作系统版本
'resolution',
//		分辨率
'mac',
//		mac地址
'apn',
//		网络地址
'clienttime',
//		客户端时间
'browser',
//		浏览器
'params',
//		参数
'abtesttype',
// ab测试使用
'type',
// 兼容老写法
'sessionid',
// 会话id
'protocolVersion' // 协议版本
];

// backup中高斯平台的不公开关键字
var notPublicKeyParameters = {
  'zpmshow': {
    // 必填参数
    'RequiredParameters': [],
    // 选填参数
    'OptionalParameters': ['pagequery', 'subpageID', 'refpagetype', 'refpagequery', 'refsubpageID', 'refsectionId', 'refsortId', 'isback', 'postid', 'machineModel', 'machineBrand']
  },
  'CommodityDetail': {
    // 必填参数
    'RequiredParameters': ['infoId'],
    // 选填参数
    'OptionalParameters': ['video', 'isshare', 'shareuid', 'parentCateId', 'cateId', 'childCateId', 'fullPath', 'brandId', 'modelId', 'sellerUid', 'refpagetype', 'refpagequery', 'refsubpageID', 'isback', 'metric']
  },
  'zpmclick': {
    // 必填参数
    'RequiredParameters': ['sectionId', 'sortId', 'sortName'],
    // 选填参数
    'OptionalParameters': ['pagequery', 'subpageID', 'jumppagequery', 'jumpurl', 'firsttab', 'secondarytab', 'tabId', 'infoId', 'user_name', 'clicktype', 'postid', 'orderId', 'orderType', 'sellerUid', 'serviceId', 'serviceName', 'cateWallWhite', 'filterOption', 'machineModel', 'machineBrand']
  },
  'longPress': {
    // 必填参数
    'RequiredParameters': ['sectionId'],
    // 选填参数
    'OptionalParameters': ['dragType']
  },
  'PopupShow': {
    // 必填参数
    'RequiredParameters': ['popupname'],
    // 选填参数
    'OptionalParameters': ['pagequery', 'user_name', 'popuptype', 'activityId', 'redId']
  },
  'PopupClick': {
    // 必填参数
    'RequiredParameters': ['popupname', 'sortId', 'sortName'],
    // 选填参数
    'OptionalParameters': ['pagequery', 'popuptype', 'activityId', 'redId']
  },
  'LengthOfStay': {
    // 必填参数
    'RequiredParameters': ['eventduration'],
    // 选填参数
    'OptionalParameters': ['pagequery', 'subpageID', 'effectivestay']
  },
  'Areaexposure': {
    // 必填参数
    'RequiredParameters': ['sectionId'],
    // 选填参数
    'OptionalParameters': ['pagequery', 'subpageID', 'firsttab', 'secondarytab', 'tabId', 'sortName', 'sortId', 'isdot', 'postid', 'serviceId', 'serviceName', 'indexList', 'cateWallWhite', 'filterOption', 'orderId']
  },
  'METRIC': {
    // 必填参数
    'RequiredParameters': ['sectionId', 'sortId', 'metric'],
    // 选填参数
    'OptionalParameters': ['pagequery', 'subpageID', 'infoId', 'sellerUid', 'parentCateId', 'cateId', 'childCateId', 'fullPath', 'brandId', 'modelId', 'postid']
  },
  'explosureGoods': {
    // 必填参数
    'RequiredParameters': ['sectionId', 'indexList', 'goodsList', 'rstmark'],
    // 选填参数
    'OptionalParameters': ['pagequery', 'subpageID', 'tabId', 'cateWallWhite', 'firsttab', 'secondarytab']
  },
  'filterGoods': {
    // 必填参数
    'RequiredParameters': ['sectionId', 'filterData'],
    // 选填参数
    'OptionalParameters': ['sortId', 'sortName', 'subpageID', 'keyWord', 'tabId', 'cateWallWhite']
  },
  'showCount': {
    // 必填参数
    'RequiredParameters': ['show'],
    // 选填参数
    'OptionalParameters': ['keyWord', 'tabId', 'cateWallWhite']
  },
  'clickCount': {
    // 必填参数
    'RequiredParameters': ['click'],
    // 选填参数
    'OptionalParameters': ['keyWord', 'tabId', 'cateWallWhite']
  },
  'Collection': {
    // 必填参数
    'RequiredParameters': [],
    // 选填参数
    'OptionalParameters': ['infoId', 'sellerUid', 'parentCateId', 'cateId', 'childCateId', 'fullPath', 'brandId', 'modelId']
  },
  'Cancelcollection': {
    // 必填参数
    'RequiredParameters': [],
    // 选填参数
    'OptionalParameters': ['infoId', 'sellerUid', 'parentCateId', 'cateId', 'childCateId', 'fullPath', 'brandId', 'modelId']
  },
  'share': {
    // 必填参数
    'RequiredParameters': [],
    // 选填参数
    'OptionalParameters': ['sharetype', 'sharemode', 'infoId', 'sellerUid', 'parentCateId', 'cateId', 'childCateId', 'fullPath', 'brandId', 'modelId']
  },
  'Message': {
    // 必填参数
    'RequiredParameters': [],
    // 选填参数
    'OptionalParameters': ['messagetype', 'infoId', 'sellerUid', 'parentCateId', 'cateId', 'childCateId', 'fullPath', 'brandId', 'modelId']
  },
  'AddToCart': {
    // 必填参数
    'RequiredParameters': ['infoId'],
    // 选填参数
    'OptionalParameters': ['parentCateId', 'cateId', 'childCateId', 'fullPath', 'brandId', 'modelId']
  },
  'AppEnd': {
    // 必填参数
    'RequiredParameters': ['eventduration'],
    // 选填参数
    'OptionalParameters': ['pagequery']
  }
};

// 校验必填参数，如果校验不通过则抛出异常

export var validationRequiredParameters = function validationRequiredParameters(param) {
  try {
    // 获取所有的key
    var keys = _typeof(param) === 'object' ? Object.keys(param) : [];
    // 过滤出keys中不在requiredParameters中的key
    var notRequiredKeys = keys.filter(function (key) {
      return !requiredParameters.includes(key);
    });
    // 如果有不在requiredParameters中的key则抛出异常
    if (notRequiredKeys.length > 0) {
      Logger.error("\u57CB\u70B9\u9519\u8BEF\uFF1Apagetype:".concat(param.pagetype, " actiontype:").concat(param.actiontype, " \u53D1\u73B0\u4F7F\u7528\u4F4D\u7F6E\u4E0D\u6B63\u786E\u7684\u53C2\u6570\uFF1A").concat(notRequiredKeys.join(','), "\uFF0C \u8BF7\u653E\u5230backup\u4E2D\u3002\u6587\u6863\uFF1Ahttps://fe.zhuanspirit.com/common/zz-sdk-doc/docs/%E6%95%B0%E6%8D%AE%E6%A0%BC%E5%BC%8F.html#_1-%E6%95%B0%E6%8D%AE%E6%A0%BC%E5%BC%8F"));
    }
  } catch (error) {}
};

// 校验关键字，如果校验不通过则抛出异常
export var validationKeywordParameters = function validationKeywordParameters(param) {
  try {
    var pagetype = param.pagetype;
    var notPublicKeyObject = notPublicKeyParameters[pagetype];
    if (notPublicKeyObject) {
      // 取出必填参数
      var _requiredParameters = notPublicKeyObject.RequiredParameters;
      // 取出选填参数
      var optionalParameters = notPublicKeyObject.OptionalParameters;
      // 过滤出keys中不在requiredParameters中的key
      var notRequiredKeys = _requiredParameters.filter(function (key) {
        return !Object.keys(param.backup).includes(key);
      });
      // 如果有不在requiredParameters中的key则抛出异常
      if (notRequiredKeys.length > 0) {
        Logger.error("\u57CB\u70B9\u9519\u8BEF\uFF1Apagetype:".concat(param.pagetype, " actiontype:").concat(param.actiontype, " backup\u4E2D\u7684\u5FC5\u586B\u53C2\u6570\uFF0C\u6CA1\u6709\u6DFB\u52A0\uFF1A").concat(notRequiredKeys.join(',')));
      }
      // 把optionalParameters是一个数组，把里面的数据都转成小写存在一个的数组里面
      var lowercaseOptionalParameters = optionalParameters.map(function (item) {
        return item.toLowerCase();
      });
      // 把参数转换成小写的，做比较。如果一样，在比较原始值，如果不一致则提示可能使用错误
      Object.keys(param.backup).forEach(function (key) {
        if (lowercaseOptionalParameters.includes(key.toLowerCase())) {
          var index = lowercaseOptionalParameters.indexOf(key.toLowerCase());
          var value = optionalParameters[index];
          if (value !== key) {
            console.log("\u57CB\u70B9\u9519\u8BEF\uFF1Apagetype:".concat(param.pagetype, " actiontype:").concat(param.actiontype, " backup\u4E2D\u7684\u9009\u586B\u53C2\u6570:").concat(key, "\u53EF\u80FD\u4F7F\u7528\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5"));
          }
        }
      });
    }
  } catch (error) {}
};